module.exports = __webpack_public_path__ + "static/img/vip2.b3fb9c0e.png";